import React from "react";
import styled from "styled-components/macro";
import BottomServiceBanner from "../../../components/ServiceBanner/BottomServiceBanner";
import TopServiceBanner from "../../../components/ServiceBanner/TopServiceBanner";
import banner from "../../../assets/images/MedicalAdherence/Pharma_CaseStudy_MedicationAdherence.webp";
import img from "../../../assets/images/MedicalAdherence/Medication Adherence.jpeg"
import BottomBanner from "../../../components/ServiceBanner/BottomBanner";


const MedicalAdherence = () => {
  

  return (
    <Container>
      <TopServiceBanner title=" Medical Adherence" banner={banner} />
      <Inner>
        <SubTitle>
          In the United States, while about 4 billion prescriptions are written
          annually, roughly one in five new prescriptions are never filled. For
          those filled, only about half are taken correctly. So, what is
          medication adherence, why is it so challenging, and what are the ways
          Lincourt Pharmacy, can help their patients, improve their medication
          adherence?
        </SubTitle>
        <Title>What is Medical Adherence?</Title>
        <SubTitle>
          Medication adherence usually refers to whether patients take their
          medications as prescribed (eg, twice daily), as well as whether they
          continue to take a prescribed medication. Medication adherence
          behavior has thus been divided into 2 main concepts, namely, adherence
          and persistence
        </SubTitle>
        <Middle>
          <MiddleInner>
            <MiddleInnerLeft>
              <MiddleTextLeft>Medical Adherence</MiddleTextLeft>
              <MiddleSubTitle>
                An estimated 50 percent or more of medications for chronic
                conditions, such as high cholesterol and diabetes, are not taken
                as prescribed. <br /> <br /> Medication non-adherence can lead to worsening
                health conditions, hospitalizations and death. Whatever the
                reason is for medication non-adherence, we have a solution for
                you. <br /> <br /> Ask one of our team members how we can help you today. Ask
                any of our staff today about our pill-packaging service and how
                you can get signed up.
              </MiddleSubTitle>
            </MiddleInnerLeft>
            <MiddleInnerRight>
              <Img src={img} alt="Medical Adherence" />
            </MiddleInnerRight>
          </MiddleInner>
        </Middle>
        <Title>Why medical adherence is important?</Title>
        <SubTitle>
          Taking the medicine as prescribed or medication adherence is important
          for controlling chronic conditions, treating temporary conditions, and
          overall long-term health and well-being.
        </SubTitle>
        <Title>What does low adherence mean?</Title>
        <SubTitle>
          Failure to adherence is a serious problem which not only affects the
          patient but also the health care system. Medication non adherence in
          patients leads to substantial worsening of disease, death and
          increased health care costs. A variety of factors are likely to affect
          adherence.
        </SubTitle>
      
      </Inner>
      <BottomServiceBanner />
      <BottomBanner />
    </Container>
  );
};

export default MedicalAdherence;

const Container = styled.div``;
const Inner = styled.div``;

const SubTitle = styled.h2`
  font-size: 25px;
  font-weight: normal;
  line-height: normal;
  text-align: center;
  padding: 0rem 3rem 3rem 3rem;
  margin-top: 2rem;
  opacity: 0.6;

  @media (max-width: 600px) {
    font-size: 18px;
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }

  @media (max-width: 460px) {
    font-size: 15px;
  }
`;

const Title = styled.h1`
  font-size: 40px;
  line-height: 1.1;
  color: var(--color-blue);
  text-align: center;
  margin-top: 3rem;

  &:hover {
    color: var(--color-red);
  }

  @media (max-width: 600px) {
    font-size: 30px;
  }
`;

const Middle = styled.div`
  background: var(--color-blue);
  clip-path: polygon(50% 10%, 100% 0, 100% 100%, 50% 90%, 0 100%, 0 0);
  padding-bottom: 5rem;
  padding-top: 5rem;
`;

const MiddleSubTitle = styled.h2`
  font-size: 20px;
  font-weight: normal;
  line-height: normal;
  text-align: center;
  padding: 0rem 3rem 1rem 3rem;
  margin-top: 1rem;
  color: white;

  @media (max-width: 600px) {
    font-size: 18px;
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }

  @media (max-width: 460px) {
    font-size: 15px;
  }
`;

const MiddleInner = styled.div`
  display: flex;
  justify-content: space-around;
  padding: 3rem;
  gap: 1rem;

  @media (max-width: 1180px) {
    flex-direction: column;
    gap: 1rem;
    margin-top: 2rem;
  }
`;

const MiddleInnerLeft = styled.div`
  flex: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  @media (max-width: 46px) {
    margin-bottom: 2rem;
  }
`;
const MiddleInnerRight = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const MiddleTextLeft = styled.h1`
  font-size: 30px;
  line-height: 1.1;
  color: white;
  margin-bottom: 1rem;
  text-align: center;

  @media (max-width: 600px) {
    font-size: 20px;
    margin-bottom: 2rem;
  }
`;

const Img = styled.img`
  width: 100%;
  height: 100%;
  box-shadow: 2px 2px 2px 8px rgba(0, 0, 0, 0.3);


  @media (max-width: 1180px) {
    width: 45%;
    height: 45%;
    margin-top: 1rem;
  }
`;
